var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolkadot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.501 11.9562C35.1162 11.9562 39.6683 9.27969 39.6683 5.97808C39.6683 2.67648 35.1162 0 29.501 0C23.8858 0 19.3337 2.67648 19.3337 5.97808C19.3337 9.27969 23.8858 11.9562 29.501 11.9562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.501 57C35.1162 57 39.6683 54.3235 39.6683 51.0219C39.6683 47.7203 35.1162 45.0438 29.501 45.0438C23.8858 45.0438 19.3337 47.7203 19.3337 51.0219C19.3337 54.3235 23.8858 57 29.501 57Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3323 20.2312C18.1399 15.3151 18.1217 9.9907 15.2916 8.33878C12.4615 6.68686 7.89124 9.33301 5.08363 14.2491C2.27602 19.1652 2.29424 24.4897 5.12433 26.1416C7.95442 27.7935 12.5247 25.1473 15.3323 20.2312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.914 42.7504C56.7216 37.8343 56.705 32.5108 53.8768 30.86C51.0486 29.2092 46.4799 31.8562 43.6723 36.7723C40.8646 41.6884 40.8813 47.0119 43.7095 48.6627C46.5377 50.3135 51.1064 47.6665 53.914 42.7504Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2929 48.6613C18.123 47.0094 18.1412 41.685 15.3336 36.7689C12.526 31.8528 7.95576 29.2066 5.12567 30.8585C2.29558 32.5105 2.27736 37.8349 5.08497 42.751C7.89258 47.6671 12.4628 50.3133 15.2929 48.6613Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8792 26.1429C56.7073 24.4921 56.724 19.1685 53.9164 14.2524C51.1088 9.33631 46.5401 6.68926 43.7119 8.34006C40.8837 9.99086 40.8671 15.3144 43.6747 20.2305C46.4823 25.1466 51.051 27.7937 53.8792 26.1429Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/Polkadot.3de069afb67afd049b69427c60277466.svg";
export { ForwardRef as ReactComponent };